<h2>
    Bedankt voor je aanvraag!
</h2>

<p>
    Je ontvangt een e-mail ter bevestiging van je aanvraag. We nemen zo snel mogelijk contact met je op om een afspraak
    in te plannen.
    <br>
    <br>
    Met vriendelijke groet,
    <br>
    GAMMA
</p>
